<template>
  <div name="demo-searchbox-codapp">
    <hrms-lov          v-model="codapp1"
                       lovType="codapp"
                       :disabled="false"
                       :nowLang="nowLang"
                       name="codapp1" />
    <hrms-lov          v-model="codapp2"
                       lovType="codapp"
                       :disabled="true"
                       :nowLang="nowLang"
                       name="codapp2" />
    <hrms-lov          v-model="codapp3"
                       lovType="codapp"
                       :disabled="false"
                       :nowLang="nowLang"
                       name="codapp2" />
    <hrms-search-box	 :receivedStore="receivedStore"
                			 :nowLang="nowLang"
                			 :searchBoxAlias="searchBoxAlias" />
  </div>
</template>

<script>
export default {
  name: 'demo-searchbox-codapp',
  data () {
    return {
      codapp1: '',
      codapp2: '',
      codapp3: '',
      nowLang: 'en',
      searchBoxAlias: 'demo-lov-codapp'
    }
  },
  methods: {
    receivedStore (params) {
      console.log(params)
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoSearchboxCodapp.vue?635388b2